import React from "react"
import {IconButton, styled} from "@mui/material"
import Icons from "../../assets/Icons"

export const widgetIconButtonOutlinedPrototype = [
    {
        key: "icon",
        type: "SELECT",
        label: "Icon",
        size: 6,
        options: Object.keys(Icons()).map((iconName) => ({
            value: iconName,
            label: iconName,
        })),
    },
    {
        key: "variant",
        type: "SELECT",
        label: "Variante",
        size: 6,
        options: [
            {value: "primary", label: "Primary"},
            {value: "secondary", label: "Secondary"},
            {value: "tertiary", label: "Tertiary"},
        ],
    },
    {
        key: "action",
        type: "STRING",
        label: "Aktion",
        size: 6,
    },
]

export const IconButtonComponent = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== "variant",
})(({theme, variant}) => ({
    ...theme.ICON_BUTTON_OUTLINED,
    ...(variant && theme.ICON_BUTTON_OUTLINED?.[variant]),
}))

const IconButtonOutlined = ({widget, triggerAction}) => {

    const onClick = () => {
        triggerAction(widget?.action)
    }

    const iconColor = widget?.iconColor ?? "currentColor"

    return (
        <IconButtonComponent variant={widget?.variant} onClick={onClick}>
            {Icons(iconColor)[widget?.icon]}
        </IconButtonComponent>
    )
}

export default IconButtonOutlined
